import { render } from "./BasicNotice.vue?vue&type=template&id=48e25506"
import script from "./BasicNotice.vue?vue&type=script&lang=js"
export * from "./BasicNotice.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__